import { Paper, Stack, Flex, Title, Group, ActionIcon } from "@mantine/core";
import { ReactNode } from "react";
import { IconX } from "@tabler/icons-react";
import { Link } from "react-router";

export default function CentredFlexPaper({
  children,
  title,
  closeButtonPath,
  withLogo = false,
}: {
  children: ReactNode;
  title?: string;
  closeButtonPath?: string;
  withLogo?: boolean;
}) {
  return (
    <Flex
      gap="md"
      justify="center"
      align="center"
      direction="column"
      style={{ height: "calc(100vh - 180px)" }}
    >
      {withLogo ? (
        <img
          src="/ges-health-logo.png"
          alt=""
          style={{
            width: "180px",
            height: "90px",
          }}
        ></img>
      ) : (
        <></>
      )}

      <Paper w={{ base: "300px", sm: "400px" }} radius="xs" p="md">
        <Stack>
          <Group justify="space-between" wrap="nowrap">
            {title ? <Title order={3}>{title}</Title> : <></>}
            {closeButtonPath ? (
              <Link to={closeButtonPath}>
                <ActionIcon variant="outline">
                  <IconX />
                </ActionIcon>
              </Link>
            ) : (
              <></>
            )}
          </Group>

          {children}
        </Stack>
      </Paper>
    </Flex>
  );
}
